module.exports = __webpack_public_path__ + "img/enrique-figueroa-princess-uakamayatl.b7d0df0.jpg";